import * as React from 'react';
import styled from 'styled-components'
import {ConstBreakPoint, ConstZIndex} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const MenuSpOverlayDefault: React.FC<IProps> = (props) => {

    const { ...DivProps} = props;

    return (
        <div {...DivProps}/>
    );
};

const MenuSpOverlay = styled(MenuSpOverlayDefault)`
    display: block
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${ConstZIndex.hamburgerOverlay}
    
    opacity: 1;
    will-change: opacity;
    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    background-color: rgba(0, 0, 0, 0.5);
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        display: none;
    }
`;

export default MenuSpOverlay;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/menu_sp_overlay.tsx